import React, { useContext } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Upselling } from '../../components/upselling/upselling'
import { track } from '../../ClevertapWrapper'
import routes from '../../router/routes'
import { clevertapEvents } from '../../labels'
import { FeatureContext } from '../../context/useFeatureFlagContext'
import { useUpselling } from '../../hooks/useUpselling'

export function Marketplace() {
    const upselling = useUpselling()

    const { search } = useLocation()
    const navigate = useNavigate()

    const { features } = useContext(FeatureContext)

    const handlerNavigate = (route: string, _track?: string) => {
        if (_track) {
            track(_track)
        }

        navigate(route)
    }

    const handlerGoModule = () => {
        upselling.updateUpselling('marketplace', true)

        const query = new URLSearchParams(search)
        const s = query.get('s')

        if (s === 'h') {
            handlerNavigate(
                `/${routes.inventory}`,
                clevertapEvents.homeLandingInventory
            )
        } else if (s === 'p') {
            handlerNavigate(
                `/${routes.products}`,
                clevertapEvents.homeLandingProducts
            )
        } else {
            handlerNavigate(
                `/${routes.orders}`,
                clevertapEvents.homeLandingOrders
            )
        }
    }
    // if (!features.marketplace) {
    //     setTimeout(() => {
    //         handlerGoModule()
    //     }, 0)

    //     return <div />
    // }

    return (
        <Upselling
            active={features.marketplace}
            feature={{
                image: require('../../assets/images/upselling/marketplace.png'),
                title: 'Ya esta disponible tu marketplace amiPASS',
                btn: {
                    title: 'Continuar',
                    action: () => {
                        handlerGoModule()
                    },
                },
            }}
            pending={{
                headtitle: 'Marketplace amiPASS',
                title: 'Expande Tu Alcance con el Marketplace amiPASS',
                text: 'Haz que tu negocio sea visible para miles de usuarios con el Marketplace amiPASS. Transforma tu comercio en una tienda online  y llega directamente a los consumidores dentro de la aplicación amiPASS.',
                list: [
                    'Aumenta tu visibilidad en el Marketplace amiPASS',
                    'Llega a miles de consumidores potenciales',
                    'Gestiona tu tienda online fácilmente desde amiPOS',
                    'Recibe pedidos y pagos de manera eficiente y segura',
                    'Potencia tus ventas sin necesidad de una tienda física',
                ],
                // btn1: {
                //     title: 'Contratar',
                //     action: () => {
                //         navigate('/subscription')
                //     },
                // },
                btn2: {
                    title: 'Hablar con Ventas',
                    action: () => {
                        window.open(
                            'https://amipass.typeform.com/to/BcTVDWHf?typeform-source=amipass.atlassian.net',
                            '_blank'
                        )
                    },
                },
                image: require('../../assets/images/upselling/marketplace.png'),
                contract: 'contratando el Plan Estándar y Pro',
            }}
        />
    )
}
